'use client'

import { useEffect, useRef } from 'react'

import { useAuthUser } from '@common/hooks/useAuthUser'

import { useUser } from '@modules/user/stores/hooks'

export function useInitializeCurrentUser() {
  const { user: auth0User, isLoading: auth0Loading } = useAuthUser()
  const { getCurrentUser } = useUser()
  const initStarted = useRef(false)

  useEffect(() => {
    if (auth0Loading || !auth0User || initStarted.current) return
    initStarted.current = true

    void getCurrentUser().catch((err) => {
      console.error('[useInitializeCurrentUser]', err)
    })
  }, [auth0Loading, auth0User, getCurrentUser])
}
